


















































































































































































import { Dialog, Upload, Button } from 'element-ui'
import { mixins } from 'vue-class-component'
import { Vue, Component, Ref, Watch } from 'vue-property-decorator'

import AddCreditCardForm from '@/components/AddCreditCardForm.vue'
import ChangePasswordForm from '@/components/ChangePasswordForm.vue'
import CreditCardItem from '@/components/CreditCardItem.vue'
import CustomerSubscriptionsForm from '@/components/CustomerSubscriptionsForm.vue'
import EmergencyContactDetailsForm from '@/components/EmergencyContactDetailsForm.vue'
import LargeAvatar from '@/components/LargeAvatar.vue'
import LoadingPlaceholder from '@/components/LoadingPlaceholder.vue'
import ConfirmationModal from '@/components/modals/ConfirmationModal.vue'
import RemoveCreditCardModal from '@/components/modals/RemoveCreditCardModal.vue'
import PersonalDetailsForm from '@/components/PersonalDetailsForm.vue'

import ChangePasswordFormModel from '@/models/change-password-form'
import CreditCard from '@/models/credit-card'
import ErrorEntities from '@/models/error-entities'
import NewCreditCardForm from '@/models/new-credit-card-form'

import { AddCreditCardModalMutationTypes } from '@/store/modules/addCreditCardModal'
import { AuthActionTypes } from '@/store/modules/auth/actions'
import { ChangePasswordModalMutationTypes } from '@/store/modules/changePasswordModal'
import { CreditCardActionTypes } from '@/store/modules/credit-cards'
import {
  CustomerActionTypes,
  CustomerMutationTypes,
} from '@/store/modules/customer'
import { StripeActionTypes } from '@/store/modules/stripe'

import FbLoginMixin from '../components/FbLoginMixin.vue'

@Component({
  components: {
    CustomerSubscriptionsForm,
    EmergencyContactDetailsForm,
    PersonalDetailsForm,
    CreditCardItem,
    AddCreditCardForm,
    LargeAvatar,
    ChangePasswordForm,
    ConfirmationModal,
    RemoveCreditCardModal,
    [Dialog.name]: Dialog,
    [Upload.name]: Upload,
    [Button.name]: Button,
    LoadingPlaceholder,
  },
})
export default class Profile extends mixins(FbLoginMixin) {
  @Ref() readonly changePasswordFormRef!: ChangePasswordForm
  @Ref() readonly addCreditCardFormRef!: AddCreditCardForm

  cardToDeleteId: number | null = null
  fbDisconnectConfirmationOpen = false

  get customer() {
    return this.$store.getters.getCurrentCustomer
  }

  get errors(): ErrorEntities {
    return this.$store.state.customer.errors
  }

  get creditCards(): CreditCard[] {
    return this.$store.getters.getCreditCards
  }

  get cardToDelete(): CreditCard | null {
    return this.$store.getters.getCreditCardById(this.cardToDeleteId)
  }

  get stripeSdkLoaded(): boolean {
    return this.$store.getters.getStripeSdkLoaded
  }

  get addCardModalVisible() {
    return this.$store.getters.getAddCreditCardModalVisible
  }

  set addCardModalVisible(value: boolean) {
    this.$store.commit(AddCreditCardModalMutationTypes.Toggle, value)
  }

  get addCardErrors() {
    return this.$store.getters.getAddCreditCardModalErrors
  }

  get changePasswordModalVisible() {
    return this.$store.getters.getChangePasswordModalVisible
  }

  get changePasswordModalErrors() {
    return this.$store.getters.getChangePasswordModalErrors
  }

  get customerLoaded(): boolean {
    return !!this.customer
  }

  @Watch('addCardModalVisible')
  onAddCreditCardModalOpen(value: boolean, oldValue: boolean) {
    if (oldValue && !value) {
      this.addCreditCardFormRef.resetForm()
    }
  }

  fbDisconnectCallback() {
    this.fbDisconnectConfirmationOpen = false
    this.onFbDisconnect()
  }

  onFbConnectClick() {
    this.onFbConnect('profile')
  }

  onFbDisconnectClick() {
    this.fbDisconnectConfirmationOpen = true
  }

  onCustomerUpdate(updates: { [field: string]: any }) {
    this.$store.dispatch(CustomerActionTypes.UpdateProfile, updates)
  }

  onEmergencyContactUpdate(updates: { [field: string]: any }) {
    this.$store.dispatch(CustomerActionTypes.UpdateEmergencyContact, updates)
  }

  onLogout() {
    this.$store.dispatch(AuthActionTypes.Logout)
  }

  onCardDeleteClick(cardId: number) {
    this.cardToDeleteId = cardId
  }

  onCardDelete() {
    this.$store.dispatch(CreditCardActionTypes.DeleteCard, this.cardToDeleteId)
    this.cardToDeleteId = null
  }

  openAddCreditCardModal() {
    this.$store.commit(AddCreditCardModalMutationTypes.Open)
  }

  onCreditCardCreate(newCard: NewCreditCardForm) {
    this.$store.dispatch(CreditCardActionTypes.AddCard, newCard)
  }

  onChangePasswordModalOpen() {
    this.changePasswordFormRef && this.changePasswordFormRef.resetForm()
    this.$store.commit(ChangePasswordModalMutationTypes.Open)
  }

  onChangePasswordModalClose() {
    this.$store.commit(ChangePasswordModalMutationTypes.Close)
  }

  onPasswordChange(changePasswordForm: ChangePasswordFormModel) {
    this.$store.dispatch(CustomerActionTypes.ChangePassword, changePasswordForm)
  }

  handleMarketingSubscriptionClick(isSubscriptionActive: boolean) {
    this.$store.dispatch(
      CustomerActionTypes.ManageSubscription,
      isSubscriptionActive,
    )
  }

  beforeAvatarUpload(image: File) {
    const isJPG = image.type === 'image/jpeg'
    const validSize = image.size / 1024 / 1024 < 2

    // TODO: Currently not working, figure out why
    if (!isJPG) {
      this.$store.commit(
        CustomerMutationTypes.UpdateAvatarError,
        'Avatar picture must be JPG format',
      )
    } else if (!validSize) {
      this.$store.commit(
        CustomerMutationTypes.UpdateAvatarError,
        'Avatar picture size can not exceed 2MB!',
      )
    } else {
      this.$store.dispatch(CustomerActionTypes.UpdateAvatar, image)
    }
  }

  created() {
    this.$store.dispatch(CreditCardActionTypes.Query)
    this.$store.dispatch(StripeActionTypes.LoadSdk)
  }
}
